import React, { forwardRef, useRef } from 'react';
import { useSetState } from "utils/functions.utils";
import styles from "./select_dropdown.module.scss";
import Assets from "../../../imports/assets.import";
import Select, { OptionProps } from "react-select";
import { IDropdownData } from "utils/interface.utils";
import { StateManagerProps } from "react-select/dist/declarations/src/useStateManager";
import _ from "lodash";
import { Colors } from 'utils/theme.utils';


interface ISelectProps extends StateManagerProps {
  color?: string,
  data: Array<IDropdownData>,
  className?: string,
  value: any,
  clear?: boolean,
  containerClassName?: string,
  error?: any,
  icon?: string,
  label?: string,
  id?: string
  iconWidth?: number,
  iconHeight?: number,
  height?: string,
  width?: string,
  isFilter?: boolean,
  onChange?: (selectedOption: any) => void;
}

export type Ref = any;

const SelectDropdown = forwardRef<Ref, ISelectProps>((props, ref) => {
  const [state, setState] = useSetState({
    isOpen: false,
    active: "",
    selectedOption: props.value,
  });

  const selectRef: any = useRef();

  const customStyles: any = {
    multiValueRemove: (provided, state) => ({
      ...provided,
      "&:hover": {
        backgroundColor: "transparent",
        color: "white",
      },
    }),
  };

  const ClearIndicator = props => {
    return (
      <div style={{ paddingRight: "10px", paddingTop: "5px" }} onClick={props.clearValue}>
        <img src={Assets.close_black} height={20} width={20} />
      </div>
    );
  };

  const gettingDropdownData = () => {
    return props.data?.map((item, index) => {
      if (item.hasOwnProperty('label') && item.hasOwnProperty('value')) {
        return item;
      } else if (item.hasOwnProperty('label') && !item.hasOwnProperty('value')) {
        return {
          //@ts-ignore
          value: item.label,
          ...item
        };
      } else {
        return item;
      }
    });
  };

  const DropdownIndicator = dropdownProps => {
    return (
      <div>
        <img src={getDropDownIndicatorIcon()} height={props.iconHeight || 16} width={props.iconWidth || 16} />
      </div>
    );
  };

  const getDropDownIndicatorIcon = () => {
    return Assets.caret_down
  }

  const CustomOption = (props: OptionProps<any>) => {
    const { children, innerRef, innerProps, isDisabled, isSelected, isFocused, data } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={"drop_down_data_container"}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: "flex-start",
          backgroundColor: isDisabled
            ? undefined
            : isSelected
              ? "#EEF4FF"
              : isFocused
                ? '#F7F7F8'
                : "#fff",
          borderRadius: "8px",
          color: isDisabled ? '#ccc' : '#000',
          cursor: isDisabled ? 'not-allowed' : 'default',
        }}
      >
        <span style={{
          color: isDisabled
            ? undefined
            : isSelected
              ? "#0027B2"
              : isFocused
                ? '#5D616F'
                : "#9094A2",
        }} className={"drop_down_data_item"}>{children}</span>
      </div>
    );
  };

  const handleChange = (selectedOption: any) => {
    setState({ selectedOption });
    if (props.onChange) {
      props.onChange(selectedOption); // Call the parent's onChange handler
    }
  }

  return (
    <div className={`dropdown_container ${props.containerClassName || ""}`} style={{ height: props.height || "100%", width: props.width || '100%' }}>
      {props.label && <div className={styles.select_dropdown_label_wrapper}>{props.label}</div>}
      <Select
        value={state.selectedOption}
        onChange={handleChange}
        ref={selectRef}
        maxMenuHeight={200}
        styles={customStyles}
        options={gettingDropdownData()}
        menuPlacement="auto"
        placeholder={props.placeholder}
        isSearchable={false}
        components={{
          DropdownIndicator,
          ClearIndicator,
          IndicatorSeparator: () => {
            return null;
          },
          Option: CustomOption,
        }}
        classNames={{
          control: state => (state.isFocused ? (props.isFilter ? styles.dropdown_control_filter_active : styles.dropdown_control_active) : (props.isFilter ? styles.dropdown_control_filter : styles.dropdown_control)),
          indicatorSeparator: state => (state.isFocused ? "dropdown_indicator_separator" : "dropdown_indicator_separator"),
          multiValue: state => (state.isFocused ? "dropdown_multi_value" : "dropdown_multi_value"),
          multiValueLabel: state => (state.isFocused ? "dropdown_multi_value_label" : "dropdown_multi_value_label"),
          valueContainer: state => (state.isDisabled ? "dropdown_input_value" : "dropdown_input_value"),
          option: state => (state.isSelected ? "menu_list_item_selected" : state.isFocused ? "menu_list_item_focused" : "menu_list_item"),
          input: state => "select_box_input",
        }}
      />
      {props.error && props.error.length > 0 && <div className="input_field_error">{props.error}</div>}
    </div>
  )
})

export default SelectDropdown;